import { useAdminMode } from "@/contexts/admin-mode-provider";
import { useEffect, useState } from "react";

/**
 * Returns a formatted countdown string (e.g. "9:42") for the admin mode auto-timeout,
 * or null if admin mode is not active.
 */
export function useAdminModeCountdown(): string | null {
  const { isAdminMode, adminModeExpiresAt } = useAdminMode();
  const [remaining, setRemaining] = useState<string | null>(null);

  useEffect(() => {
    if (!isAdminMode || !adminModeExpiresAt) {
      setRemaining(null);
      return;
    }

    const update = () => {
      const diff = Math.max(0, adminModeExpiresAt - Date.now());
      const totalSeconds = Math.ceil(diff / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      setRemaining(`${minutes}:${String(seconds).padStart(2, "0")}`);
    };

    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [isAdminMode, adminModeExpiresAt]);

  return remaining;
}
